namespace GeniuzPOS.Inventory {
    export interface IcStockApproveDtRow {
        SysDocNo?: string;
        SkuCode?: string;
        WhsId?: string;
        QtyOnhand?: number;
        UnitCost?: number;
        SkuDesc?: string;
        StkUnit?: string;
        QtyCount?: number;
        QtyDif?: number;
        CostValue?: number;
    }

    export namespace IcStockApproveDtRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockApproveDt';
        export const deletePermission = '2Inventory:ตรวจนับ:อนุมัติ:Modify';
        export const insertPermission = '2Inventory:ตรวจนับ:อนุมัติ:Modify';
        export const readPermission = '2Inventory:ตรวจนับ:อนุมัติ:View';
        export const updatePermission = '2Inventory:ตรวจนับ:อนุมัติ:Modify';

        export declare const enum Fields {
            SysDocNo = "SysDocNo",
            SkuCode = "SkuCode",
            WhsId = "WhsId",
            QtyOnhand = "QtyOnhand",
            UnitCost = "UnitCost",
            SkuDesc = "SkuDesc",
            StkUnit = "StkUnit",
            QtyCount = "QtyCount",
            QtyDif = "QtyDif",
            CostValue = "CostValue"
        }
    }
}
